export default __webpack_public_path__ + "static/media/knowledge1.8d5f7bcd.png";